import React from 'react';

const Logo: React.FC = () => {
  return <div className="logo" />;
};

export default Logo;
